module.exports = __webpack_public_path__ + "static/media/Thanh_Hung.dbf8b44c.svg";